import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, X } from "lucide-react";

import styles from "./Header.module.css";

function getPageTitle(pathname: string) {
  if (pathname === "/product" || pathname.startsWith("/service-products") || pathname.startsWith("/public-service")) {
    return "Explorar";
  }
  if (pathname === "/calendar" || pathname.startsWith("/recurrent-bookings")) {
    return "Reservas";
  }
  if (pathname === "/statistics") {
    return "Fidelis Score";
  }
  if (pathname === "/user") {
    return "Mi espacio";
  }
  if (pathname.startsWith("/profile")) {
    return "Perfil";
  }
  if (pathname.startsWith("/notifications")) {
    return "Notificaciones";
  }
  if (pathname.startsWith("/documents")) {
    return "Documentos";
  }
  if (pathname.startsWith("/settings")) {
    return "Configuracion";
  }
  if (pathname.startsWith("/ewallet")) {
    return "Monedero";
  }
  if (pathname.startsWith("/payment-methods")) {
    return "Metodos de pago";
  }
  if (pathname.startsWith("/favorites")) {
    return "Favoritos";
  }
  if (pathname.startsWith("/add-coupons")) {
    return "Cupones";
  }

  return "Fidelis";
}

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const title = useMemo(() => getPageTitle(location.pathname), [location.pathname]);

  return (
    <header className={styles.header}>
      <div className={styles.topbar}>
        <div className={styles.brandGroup}>
          <button className={styles.backButton} onClick={() => navigate(-1)} aria-label="Volver">
            <ArrowLeft size={20} />
          </button>

          <div className={styles.brandBlock}>
            <span className={styles.brandMark}>F</span>
            <div className={styles.brandText}>
              <span className={styles.brandName}>Fidelis</span>
              <span className={styles.pageTitle}>{title}</span>
            </div>
          </div>
        </div>

      </div>
    </header>
  );
}

export function ModalHeader({ onBack }: { onBack: () => void }) {
  const location = useLocation();
  const title = useMemo(() => getPageTitle(location.pathname), [location.pathname]);

  return (
    <header className={styles.header}>
      <div className={styles.topbar}>
        <div className={styles.brandGroup}>
          <button className={styles.backButton} onClick={onBack} aria-label="Cerrar">
            <X size={20} />
          </button>

          <div className={styles.brandBlock}>
            <span className={styles.brandMark}>F</span>
            <div className={styles.brandText}>
              <span className={styles.brandName}>Fidelis</span>
              <span className={styles.pageTitle}>{title}</span>
            </div>
          </div>
        </div>

      </div>
    </header>
  );
}
